import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { ClientLabelWithId } from '../../../../entities/ClientLabel'

export const fetchClientLabels = createAsyncThunk<
	ClientLabelWithId[],
	void,
	ThunkConfig<string>
>(
	'fetchClientLabels',
	async (_, thunkAPI) => {

		const { extra: { api }, rejectWithValue } = thunkAPI

		try {
			const res = await api.get<ClientLabelWithId[]>('/clientLabels')
			return res.data
		} catch (e) {
			console.log(e)
			appHandleError(e, 'fetchClientLabels', 'Error on fetching client labels')
			return rejectWithValue('Error occurred on fetching client labels')
		}
	})
